'use client';

import { useRedirectToUserCompany } from 'hooks/auth/companyRedirect';

/**
 * Runs `useRedirectToUserCompany` and renders nothing.
 *
 * The hook reads `useSearchParams()`, which excludes its whole client subtree from
 * static prerendering — so calling it in the same component that renders
 * `AuthProtection` would ship the login pages as an empty shell and only paint the
 * form after hydration, where the Pages Router versions prerendered the full markup.
 *
 * Isolating the hook here keeps the bailout confined to a component with no output:
 * the page wraps only this in <Suspense>, and the form prerenders as before (#489).
 */
export const LoginRedirect = () => {
  useRedirectToUserCompany();

  return null;
};
